/**
 * These are assumed levels based on normal console object. They are ordered from least-priority to
 * highest priority.
 */
const levels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
}

module.exports = levels
